<template>
	<div class="no-auth">
		<div v-if="isAuth">
			<slot></slot>
		</div>
		<el-card v-else>
			<div class="content">
				<div class="left">
					<img src="https://cdn.dkycn.cn/melyshop/image/20210831-9a54f3fa-4a97-4df5-80f8-0c82ceaa0d56.png">
					<div class="info">
						<div class="tit">好友欢迎语</div>
						<div class="tip">配置好友欢迎语，客户将在添加员工企业微信为好友后收到该欢迎语；欢迎语可配置文本消息、图文链接、二维码图片、小程序卡片等。</div>
					</div>
				</div>
				<div class="right">
					<el-button type="primary" @click="handleUse">授权安装企店助手</el-button>
				</div>
			</div>
			<div style="margin-top:25px">
				<div class="desc-title">1/功能说明</div>
				<img style="display: block;width:100%;max-width: 885px;" src="https://cdn.dkycn.cn/melyshop/image/20210831-dcd704ed-a2e3-4447-9f5f-69333990e841.png"></img>
				<div class="desc-title">2/欢迎语配置</div>
				<img style="display: block;max-width: 885px;" src="https://cdn.dkycn.cn/melyshop/image/20210831-3b121291-a81f-4c66-a007-3019053ca7d8.png"></img>
			</div>
		</el-card>
	</div>
</template>

<script>
	import {
		qyweixinsuiteauthinfo
	} from "@/api/sv1.0.0";
	import config from "@/config/index";

	export default {
		components: {},
		data() {
			return {
				isAuth: true,
				goUrls: config.GO_URL,
			};
		},
		beforeMount() {
			this.getData();
		},
		methods: {
			async getData(callback) {
				try {
					const res = await qyweixinsuiteauthinfo();
					this.isAuth = res.Result.IsFinishQyWeixinSuiteStp;
				} catch (e) {
				}
			},
			handleUse() {
				// let headsUrls = process.env.NODE_ENV == 'production' ? 'index.html#' : ''
				// let url = this.goUrls + headsUrls + '/saleChannel/qyWechat'
				// window.open(url)
				this.$router.push({
					path: '/saleChannel/qyWechat'
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.desc-title{
		font-weight: bold;
		margin-top: 30px;
		font-size: 16px;
		margin-bottom: 10px;
	}
	.desc-content{
		font-size: 14px;
		color: #606266;
		line-height: 20px;
		
		>div{
			margin-bottom: 5px;
		}
	}
	.content {
		display: flex;
		align-items: center;
		overflow: hidden;
		padding: 15px;
		background-color: #f8f8f9;
		
		
	
		.left {
			flex: 1 1 auto;
			overflow: hidden;
			margin-right: 20px;
			display: flex;
	
			img {
				flex: 0 0 auto;
				width: 46px;
				height: 46px;
			}
	
			.info {
				flex: 1 1 auto;
				overflow: hidden;
				margin-left: 10px;
				padding-top: 2px;
	
				.tit {
					font-size: 14px;
					font-weight: bold;
				}
	
				.tip {
					font-size: 12px;
					color: #999;
					margin-top: 10px;
				}
			}
		}
	
		.right {
			flex: 0 0 auto;
		}
	}
</style>
